export const environment = {

	title: 'Noggin 2 Unified Twilio Routing Table',
	dynamoDbEndPointUrl: '',

};
